import currencyToDecimalLength from 'src/internal/currency-formatter/currencyToDecimalLength';

/**
 * Returns the number of fractional digits for a given currency.
 */
export default function getCurrencyDigits(currency: string): number {
  return currencyToDecimalLength(currency.toLowerCase());
}
